
import React, { Component } from "react";
import { connect } from "react-redux";
import AuthService from "../../services/AuthService";
import * as Actions from "../../reducers/actions";
import { Tabs,Spin, Icon,Button } from 'antd';
import { parse } from 'qs'
import {
  Redirect
} from "react-router-dom";
import {  Link, } from "react-router-dom";
import Xpage6ef04dc07 from "./xpage6/ef04dc07";
import Xpage6ef04dc08 from "./xpage6/ef04dc08";
import Xpage6ef04dc09 from "./xpage6/ef04dc09";
import Xpage6ef06dc11 from "./xpage6/ef06dc11";
import Xpage6ef04dc17 from "./xpage6/ef04dc17";
import Xpagenewtab13 from "./xpage6/newtab13";

import Config from "../../config";
import {objSearch} from "../../utils/func";
const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;
const TabPane = Tabs.TabPane;

class XMain6 extends Component {
  constructor(props) {
    super(props);
    this.state = { activeKey: '', isBack: false, plt_bld_id: '', year: '',data1:[]};
    const query = this.props.location && this.props.location.search?parse(this.props.location.search.substr(1)):{}
    setTimeout(()=>{
        if(!query.plt_bld_id || !query.year){
            this.setState({ isBack :true });
        }else{
            this.setState({ plt_bld_id:query.plt_bld_id, year:query.year,time:query.time,activeKey:query.page?query.page:'1'});
        }
    },100)

    this.getPdfStep(query.year, query.plt_bld_id);
  }
  getPdfStep(year, plt_bld_id) {
    let token = localStorage.getItem("ef_token");
    return fetch(Config.api + `/api/getPdfExport?token=${token}&plt_bld_id=${plt_bld_id}&year=${year}`, {
      headers: { "Content-Type": "application/json", }
    }).then(response => response.json())
      .then(data => {
        if (data.resultCode == 20000 && data.data && data.data.length > 0) {
          let ff = data.data.filter(r => r.STEP_NO === 9)
          if (ff.length > 0){
            this.setState({ data1: ff[0] });
          }
        }
        console.log("getPdfStep", data);
      }, err => {
        console.log("getPdfStep", err);
      });
  }


  render() {
      let { data1,activeKey,isBack, plt_bld_id, year,time } = this.state
    console.log(data1)
    let token = localStorage.getItem("ef_token");
    return <div className="App" style={{ background: "#F7F7F8" }}>
        <div>
        <Button type="primary" disabled={!((data1.STEP_NO === 9 ) && (data1.EXPORT_STATUS ==="9"||data1.EXPORT_STATUS ==="10") )} onClick={() => {
          window.open('http://122.155.13.121/Eform/' + data1.URL_DOWNLOAD, "_blank");
            }} class="" style={{  verticalAlign: "top", height: "32px", right: 370, top: "110px", position: "absolute" }}>
            <img src="images/iPrint.png" />
            &nbsp;รายการจัดการพลังงาน
          </Button>

          <Button type="primary" onClick={() => {
              window.open(Config.api + `/api/print/3?token=${token}&plt_bld_id=${plt_bld_id}&year=${year}&xtime=${time}`, "_blank");
            }} style={{ verticalAlign: "top", height: "32px", right: 210, top: "110px", position: "absolute" }}>
            <img src="images/iPrint.png" />
            &nbsp;รายการตรวจสอบ
          </Button>
          <Button type="primary" onClick={() => {
              window.open(Config.api + `/api/print/6?token=${token}&plt_bld_id=${plt_bld_id}&year=${year}&xtime=${time}`, "_blank");
            }} style={{ verticalAlign: "top", height: "32px", right: 12, top: "110px", position: "absolute" }}>
            <img src="images/iPrint.png" />
            &nbsp;รายการผลการตรวจสอบ
          </Button>
          {/* <button type="button" onClick={() => {
              window.open(Config.api + `/api/print/3?token=${token}&plt_bld_id=${plt_bld_id}&year=${year}&xtime=${time}`, "_blank");
            }} class="" style={{ verticalAlign: "top", height: "32px", right: 260, top: "100px", position: "absolute" }}>
            <img src="images/iPrint.png" />
            &nbsp;รายการตรวจสอบ
          </button>
          <button type="button" onClick={() => {
              window.open(Config.api + `/api/print/6?token=${token}&plt_bld_id=${plt_bld_id}&year=${year}&xtime=${time}`, "_blank");
            }} class="" style={{ verticalAlign: "top", height: "32px", right: 0, top: "100px", position: "absolute" }}>
            <img src="images/iPrint.png" />
            &nbsp;รายการผลการตรวจสอบ
          </button> */}
        </div>

        {!this.props.token ? <Redirect to="/" /> : <div />}
        {isBack ? <Redirect to="/main" /> : <div />}
        <div id="wrapper">
          <div id="body" style={{ visibility: "visible", padding: "10px 0px" }}>
            <div className="card-container">
              <div className="card-container">
                <Tabs type="card" activeKey={activeKey} onChange={p => {
                    this.setState({ activeKey: p });
                    this.props.history.replace({
                      pathname: "/xpage6",
                      search: objSearch({
                        plt_bld_id: plt_bld_id,
                        year: year,
                        time: time,
                        page: p
                      })
                    });
                  }}>
                  <TabPane tab="กำหนดความรับผิดชอบฯ" key="1">
                    {activeKey == "1" && plt_bld_id && year ? <Xpage6ef04dc07 plt_bld_id={plt_bld_id} year={year} key={0} time={time} /> : <Spin indicator={antIcon} />}
                  </TabPane>

                  <TabPane tab="สัมภาษณ์" key="2">
                    {activeKey == "2" && plt_bld_id && year ? <Xpage6ef04dc08 plt_bld_id={plt_bld_id} year={year} key={0} time={time} /> : <Spin indicator={antIcon} />}
                  </TabPane>
                  <TabPane tab="ขั้นตอนที่ 1" key="3">
                    {activeKey == "3" && plt_bld_id && year ? <Xpage6ef04dc09 plt_bld_id={plt_bld_id} year={year} key={0} step={1} time={time} /> : <Spin indicator={antIcon} />}
                  </TabPane>
                  <TabPane tab="ขั้นตอนที่ 2" key="4">
                    {activeKey == "4" && plt_bld_id && year ? <Xpage6ef04dc09 plt_bld_id={plt_bld_id} year={year} key={1} step={2} time={time} /> : <Spin indicator={antIcon} />}
                  </TabPane>
                  <TabPane tab="ขั้นตอนที่ 3" key="5">
                    {activeKey == "5" && plt_bld_id && year ? <Xpage6ef04dc09 plt_bld_id={plt_bld_id} year={year} key={2} step={3} time={time} /> : <Spin indicator={antIcon} />}
                  </TabPane>
                  <TabPane tab="ขั้นตอนที่ 4" key="6">
                    {activeKey == "6" && plt_bld_id && year ? <Xpage6ef04dc09 plt_bld_id={plt_bld_id} year={year} key={3} step={4} time={time} /> : <Spin indicator={antIcon} />}
                  </TabPane>
                  <TabPane tab="ขั้นตอนที่ 5" key="7">
                    {activeKey == "7" && plt_bld_id && year ? <Xpage6ef04dc09 plt_bld_id={plt_bld_id} year={year} key={4} step={5} time={time} /> : <Spin indicator={antIcon} />}
                  </TabPane>
                  <TabPane tab="ขั้นตอนที่ 6" key="8">
                    {activeKey == "8" && plt_bld_id && year ? <Xpage6ef04dc09 plt_bld_id={plt_bld_id} year={year} key={5} step={6} time={time} /> : <Spin indicator={antIcon} />}
                  </TabPane>
                  <TabPane tab="ขั้นตอนที่ 7" key="9">
                    {activeKey == "9" && plt_bld_id && year ? <Xpage6ef04dc09 plt_bld_id={plt_bld_id} year={year} key={6} step={7} time={time} /> : <Spin indicator={antIcon} />}
                  </TabPane>
                  <TabPane tab="ขั้นตอนที่ 8" key="10">
                    {activeKey == "10" && plt_bld_id && year ? <Xpage6ef04dc09 plt_bld_id={plt_bld_id} year={year} key={7} step={8} time={time} /> : <Spin indicator={antIcon} />}
                  </TabPane>
                  <TabPane tab="ผลสรุปการตรวจสอบ" key="11">
                    {activeKey == "11" && plt_bld_id && year ? <Xpage6ef06dc11 plt_bld_id={plt_bld_id} year={year} key={0} time={time} /> : <Spin indicator={antIcon} />}
                  </TabPane>
                  <TabPane tab="คำรับรอง" key="12">
                    {activeKey == "12" && plt_bld_id && year ? <Xpage6ef04dc17 plt_bld_id={plt_bld_id} year={year} key={0} time={time} /> : <Spin indicator={antIcon} />}
                  </TabPane>
                  <TabPane tab="ความก้าวหน้า" key="13">
                    {activeKey == "13" && plt_bld_id && year ? <Xpagenewtab13 plt_bld_id={plt_bld_id} year={year} key={0} time={time} /> : <Spin indicator={antIcon} />}
                  </TabPane>
                </Tabs>
              </div>
            </div>
          </div>
        </div>
      </div>;
  }
}
function mapStateToProps(state) {
  return { token: state.default.token, user: state.default.user };
}

export default connect(mapStateToProps)(XMain6);
// export default Singin;


// WEBPACK FOOTER //
// ./src/view/main/xpage6.js